
















import { useTranslate } from '@front-app/hooks/useTranslate';
import { computed, defineComponent } from '@vue/composition-api';
import {
	COUNTRY_OPTIONS,
	CODE_TO_COUNTRY,
	EMPTY_COUNTRY,
} from './CountryPickerData';
import SelectBox from './SelectBox.vue';
import { SelectBoxChoice } from './SelectBoxModel';

const DEFAULT_VALUE = 'CA';

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: String,
			default: DEFAULT_VALUE,
		},
		allowNoneOption: Boolean,
	},
	setup(props, ctx) {
		const $t = useTranslate(ctx);
		const computedValue = computed(() => {
			if (props.allowNoneOption) {
				return CODE_TO_COUNTRY[props.value] ? props.value : EMPTY_COUNTRY;
			}
			return CODE_TO_COUNTRY[props.value] ? props.value : DEFAULT_VALUE;
		});
		const countryOptions = computed(() => {
			if (props.allowNoneOption) {
				const val: SelectBoxChoice = {
					key: EMPTY_COUNTRY,
					label: $t('none') as unknown as string,
				};
				return [val].concat(COUNTRY_OPTIONS);
			}
			return COUNTRY_OPTIONS;
		});
		const countryName = computed(() => {
			const val = CODE_TO_COUNTRY[computedValue.value];
			if (!val) {
				return $t('none') as unknown as string;
			}
			return val.countryName;
		});
		return {
			computedValue,
			countryOptions,
			countryName,
		};
	},
});
